import styleInject from 'style-inject';

var css_248z = ".Line-module_line__vyJ2- {\n\tdisplay: block;\n\tmargin-bottom: 6px;\n\tbackground: var(--qd-color-lighter-grey);\n\tborder-radius: 10px;\n}\n\n.Line-module_darkLine__EjuZv {\n\tbackground: var(--qd-color-grey);\n}\n\n.Line-module_blueLine__WMJxu {\n\tbackground: var(--qd-color-blue);\n\tborder-radius: 2px;\n}\n";
var styles = {"line":"Line-module_line__vyJ2-","darkLine":"Line-module_darkLine__EjuZv","blueLine":"Line-module_blueLine__WMJxu"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
